export const ptBRSettings = {
  title: 'Configuracoes',
  profile: {
    title: 'Perfil',
    name: 'Nome',
    email: 'E-mail',
  },
  preferences: {
    title: 'Preferencias',
    language: 'Idioma',
    languageSaved: 'Idioma atualizado',
    languageSaveError: 'Erro ao salvar idioma',
  },
  management: {
    title: 'Gerenciamento',
    categories: 'Categorias',
    categoriesDescription: 'Organize suas despesas por categorias',
    accounts: 'Contas',
    accountsDescription: 'Gerencie suas contas bancarias e cartoes',
  },
  household: {
    title: 'Residencia',
    name: 'Nome',
    members: 'Membros',
    manager: 'Gerente',
    member: 'Membro',
    saved: 'Residencia atualizada',
    saveError: 'Erro ao salvar',
  },
  security: {
    title: 'Seguranca',
    pinLock: 'Bloqueio por PIN',
    pinLockDescription: 'Exigir PIN de 4 digitos para desbloquear o app',
    enablePin: 'Ativar PIN',
    disablePin: 'Desativar PIN',
    changePin: 'Alterar PIN',
    enterPasswordToEnable: 'Digite sua senha para ativar o bloqueio por PIN.',
    password: 'Senha',
    passwordRequired: 'Senha obrigatoria',
    enterNewPin: 'Novo PIN',
    choosePin: 'Escolha um PIN de 4 digitos.',
    chooseNewPin: 'Escolha um novo PIN de 4 digitos.',
    confirmPin: 'Confirmar PIN',
    confirmPinDescription: 'Digite o PIN novamente para confirmar.',
    enterCurrentPin: 'PIN atual',
    enterCurrentPinDescription: 'Digite seu PIN atual para continuar.',
    enterPinToDisable: 'Digite seu PIN atual para desativar o bloqueio.',
    currentPin: 'PIN atual',
    newPin: 'Novo PIN',
    pinMustBe4Digits: 'O PIN deve ter exatamente 4 digitos',
    pinsDontMatch: 'Os PINs nao conferem',
    pinEnabled: 'PIN ativado',
    pinDisabled: 'PIN desativado',
    pinChanged: 'PIN alterado',
    pinError: 'Erro ao processar PIN',
    next: 'Proximo',
    enable: 'Ativar',
    disable: 'Desativar',
    change: 'Alterar',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    idleTimeout: 'Bloquear apos',
    idleTimeoutDescription: 'Bloquear o app apos este periodo de inatividade',
    idleTimeout1: '1 minuto',
    idleTimeout5: '5 minutos',
    idleTimeout15: '15 minutos',
    idleTimeout30: '30 minutos',
    lockOnHide: 'Bloquear ao ocultar aba',
    lockOnHideDescription: 'Bloquear o app ao trocar para outra aba',
    lockScreen: {
      title: 'App bloqueado',
      subtitle: 'Digite seu PIN para continuar',
      pinLabel: 'PIN de desbloqueio',
      wrongPin: 'PIN incorreto (tentativa {{attempts}} de 5)',
      attemptsRemaining: '{{count}} tentativas restantes',
    },
  },
  integrations: {
    title: 'Integracoes',
    googleDrive: 'Google Drive',
    connectDescription: 'Conecte o Google Drive para enviar comprovantes das suas despesas',
    connect: 'Conectar Google Drive',
    disconnect: 'Desconectar',
    connected: 'Conectado',
    notConnected: 'Nao conectado',
    connectedSince: 'Conectado em {{date}}',
    disconnectConfirmTitle: 'Desconectar Google Drive?',
    disconnectConfirmDescription: 'Os comprovantes ja salvos no Drive nao serao excluidos, mas voce nao podera enviar novos comprovantes ate reconectar.',
    disconnectConfirmAction: 'Desconectar',
    disconnectConfirmCancel: 'Cancelar',
    toastConnected: 'Google Drive conectado',
    toastDisconnected: 'Google Drive desconectado',
    toastErrorDenied: 'O acesso ao Google Drive foi negado',
    toastErrorFailed: 'Falha ao conectar Google Drive',
    toastDisconnectError: 'Falha ao desconectar Google Drive',
    rootFolder: 'Pasta de comprovantes',
    rootFolderNotSet: 'Nenhuma pasta selecionada',
    selectRootFolder: 'Selecionar pasta',
    changeRootFolder: 'Alterar pasta',
    rootFolderSelected: 'Pasta "{{name}}" selecionada',
    rootFolderError: 'Erro ao selecionar pasta',
    itemPictureFolder: 'Pasta de fotos de itens',
    itemPictureFolderNotSet: 'Nenhuma pasta selecionada',
    selectItemPictureFolder: 'Selecionar pasta',
    changeItemPictureFolder: 'Alterar pasta',
    itemPictureFolderSelected: 'Pasta "{{name}}" selecionada',
    itemPictureFolderError: 'Erro ao selecionar pasta',
    googleCalendar: 'Google Calendar',
    calendarDescription: 'Escolha qual Google Calendar armazena os eventos da familia',
    calendarConnectHint: 'Conecte o Google Drive acima para habilitar a selecao de calendario',
    selectedCalendar: 'Calendario selecionado',
    calendarNotSet: 'Nenhum calendario selecionado',
    selectCalendar: 'Selecionar calendario',
    changeCalendar: 'Alterar calendario',
    calendarPickerPlaceholder: 'Escolha um calendario…',
    calendarSelected: 'Calendario "{{name}}" selecionado',
    calendarSelectError: 'Erro ao selecionar calendario',
    calendarListError: 'Erro ao carregar calendarios - tente reconectar o Google',
  },
  invites: {
    title: 'Convites',
    description: 'Convide pessoas para sua household',
    createInvite: 'Criar convite',
    createInviteWithEmail: 'Criar e enviar e-mail',
    emailOptional: 'E-mail (opcional)',
    emailPlaceholder: 'convidado@exemplo.com',
    linkCopied: 'Link de convite copiado!',
    copyLink: 'Copiar link',
    sent: 'Convite criado',
    sentWithEmail: 'Convite enviado para {{email}}',
    revoke: 'Revogar',
    revokeConfirm: 'Revogar este convite?',
    revoked: 'Convite revogado',
    noInvites: 'Nenhum convite ainda',
    status: {
      active: 'Ativo',
      used: 'Usado',
      expired: 'Expirado',
    },
    expiresIn: 'Expira {{date}}',
    usedBy: 'Usado',
    createdBy: 'por {{name}}',
    error: 'Falha ao criar convite',
    revokeError: 'Falha ao revogar convite',
  },
  mural: {
    title: 'Mural',
    groceriesListLabel: 'Lista de compras do Mural',
    groceriesListHelp:
      'A lista mostrada pelo botão Mercado nas telas pareadas, e onde entram os itens adicionados pelo Mural.',
    automatic: 'Automático',
    automaticWithList: '({{name}})',
    noLists: 'Nenhuma lista ainda.',
    createList: 'Crie uma em Listas',
    saved: 'Lista do Mural atualizada',
    saveError: 'Falha ao salvar a lista do Mural',
    loadError: 'Não foi possível carregar as configurações do Mural',
    retry: 'Tentar novamente',
  },
  devices: {
    title: 'Dispositivos',
    description: 'Pareie uma tela Mural digitando o código que ela mostra.',
    codeLabel: 'Código de pareamento',
    codePlaceholder: 'ABCD-EFGH',
    approve: 'Parear dispositivo',
    approved: 'Dispositivo pareado',
    codeRequired: 'Digite o código mostrado na tela',
    errorNotFound: 'Nenhum pareamento encontrado para esse código — confira a tela e tente de novo',
    errorExpired: 'Esse código expirou — atualize a tela para gerar um novo',
    errorUsed: 'Esse código já foi usado',
    errorRateLimited: 'Muitas tentativas — aguarde um minuto e tente de novo',
    errorGeneric: 'Falha ao parear dispositivo',
    listTitle: 'Dispositivos pareados',
    noDevices: 'Nenhum dispositivo pareado ainda',
    lastSeen: 'Visto {{when}}',
    neverSeen: 'Nunca visto',
    pairedBy: 'Pareado por {{name}} em {{date}}',
    pairedOn: 'Pareado em {{date}}',
    listError: 'Não foi possível carregar os dispositivos',
    retry: 'Tentar de novo',
    revoke: 'Revogar',
    revokeAriaLabel: 'Revogar {{name}}',
    revokeConfirmTitle: 'Revogar {{name}}?',
    revokeConfirmDescription:
      'A tela deixa de mostrar os dados da casa imediatamente e precisará ser pareada de novo para voltar.',
    revokeConfirmCancel: 'Cancelar',
    revoked: 'Dispositivo revogado',
    revokeError: 'Falha ao revogar dispositivo',
  },
  notifications: {
    title: 'Notificacoes',
    pushNotifications: 'Notificacoes push',
    pushDescription: 'Receba notificacoes no navegador quando contas estiverem vencendo ou atrasadas',
    enable: 'Ativar notificacoes',
    disable: 'Desativar notificacoes',
    enabled: 'Notificacoes ativadas',
    disabled: 'Notificacoes desativadas',
    permissionDenied: 'Notificacoes estao bloqueadas pelo navegador. Ative-as nas configuracoes do navegador.',
    notSupported: 'Notificacoes push nao sao suportadas neste navegador.',
    iosNote: 'No iOS, notificacoes push requerem iOS 16.4+ e o app deve ser adicionado a tela inicial.',
    enableSuccess: 'Notificacoes ativadas',
    enableError: 'Falha ao ativar notificacoes',
    disableSuccess: 'Notificacoes desativadas',
    disableError: 'Falha ao desativar notificacoes',
  },
} as const;
